import { React } from "react"
import PSPage from "components/globals/ui/layout/Page"
import {
  PSCollapsableContainer,
  PSCollapsableContainerHeading,
  PSCollapsableContainerContent,
} from "components/globals/ui/PSCollapsableContainer";

const ChangelogContainer = function({startShown, version, date, children}) {
  return (
    <PSCollapsableContainer startShown={startShown}>
      <PSCollapsableContainerHeading>
        <div className="flex items-center py-3">
          <div className="inline-block bg-black text-white font-mono text-[14px] rounded-md">
            <span className="py-2 px-3  inline-block border-r-grey border-r-[1px]">
            {version}
            </span>
            <span className="inline-block py-2 pl-6 pr-7">
            {date}
            </span>
          </div>
        </div>
      </PSCollapsableContainerHeading>

      <PSCollapsableContainerContent>
        <div className="ors-rich-text mt-3">{children}</div>
      </PSCollapsableContainerContent>
    </PSCollapsableContainer>
  )
}

const Changelog = () => {
  return (
    <>
      <PSPage>
        <h1 className="text-3xl  mb-small my-md">Open Road Society: Changelog</h1>

        <div className="mb-md">

          <ChangelogContainer startShown version="1.41" date="June 9th, 2025">
            <ul>
              <li>Car page main gallery is now a free-scroll container where the images maintain their original aspect ratio</li>
            </ul>
          </ChangelogContainer>

          <ChangelogContainer version="1.4" date="May 30th, 2025">
            <ul>
              <li>Car Notes</li>
              <ul>
                <li>You have the ability to create notes per car</li>
                <li>Notes show up in your dashboard under "Notes/Resources"</li>
                <li>Added notes (only for you to see) on the car detail page</li>
                <li>Created a detail page which shows the note content</li>
              </ul>
              <li>Car Resources</li>
              <ul>
                <li>You have the ability to create resources, which you assign a make/model to</li>
                <li>Resources show up in your dashboard under "Notes/Resources"</li>
                <li>On the model page (/porsche/911) there will be a list of resources</li>
                <li>Created a detail page which shows the resource content</li>
              </ul>
              <li>Split Rallys page between upcoming and past events</li>
              <li>On events detail page, the image is the real aspect ratio so you can see all of the image</li>
              <li>On mobile, row images are wider</li>
              <li>Added quantity of cars for each brand on the listing page /cars/brands</li>
              <li>Restyled the new post panel</li>
            </ul>
          </ChangelogContainer>

          <ChangelogContainer version="1.3" date="May 28th, 2025">
            <ul>
              <li>New Garage Car multi-step form</li>
              <ul>
                <li>5 steps each with a dedicated form panel</li>
                <li>Updated the style of the forms and the containers</li>
                <li>Each section saves before proceeding to the next stage</li>
              </ul>
              <li>Support for car mods</li>
              <ul>
                <li>In the new garage car form, you can set up mods</li>
                <li>Multiple mods can be associated with each car</li>
                <li>Mods have support for a type/category, text area, title, and gallery</li>
                <li>Mods show up on the car detail page</li>
              </ul>
              <li>Support for multiple car galleries</li>
              <ul>
                <li>In the new garage car form, you can set up galleries</li>
                <li>Multiple galleries can be associated with each car</li>
                <li>Galleries have support for a type/category, text area, title, and the images</li>
                <li>Galleries show up as a grid of 'albums' on the car detail page</li>
              </ul>
              <li>Adjusted the color scheme for the confirmation delete modal</li>
              <li>Added car year-make-model to the stablemates section of a car detail page</li>
            </ul>
          </ChangelogContainer>

           <ChangelogContainer version="1.26" date="May 22nd, 2025">
            <ul>
              <li>Better mobile navigation</li>
              <li>New images for main pages</li>
              <li>Added discord links</li>
            </ul>
          </ChangelogContainer>
           
           <ChangelogContainer version="1.25" date="May 20th, 2025">
            <ul>
              <li>Support for videos in posts</li>
              <li>New and upgraded rich text editor for all forms</li>
              <li>added the drive article to the home page</li>
              <li>Stopped the home carousel from animating quickly when you come back from another tab</li>
              <li>New car profile page</li>
              <ul>
                <li>New header layout</li>
                <li>New car grid attributes layout</li>
                <li>Use a real user row with follow and email buttons</li>
                <li>New gallery layout</li>
                <li>Full description moved to the bottom</li>
              </ul>
              <li>Small UI tweaks to user rows</li>
            </ul>
          </ChangelogContainer>

          <ChangelogContainer version="1.24" date="May 17th, 2025">
            <ul>
              <li>Fixed an issue where phone uploads would sometimes save upside down</li>
              <li>Fixed an issue where followers weren't notified when you added or edited your garage cars</li>
              <li>Logo in the header no longer shrinks on mobile</li>
              <li>Temp disable youtube links</li>
              <li>Move menu toggle button to the left side of the screen on mobile</li>
            </ul>
          </ChangelogContainer>
          
          <ChangelogContainer version="1.23" date="May 14th, 2025">
            <ul>
              <li>New user dashboard</li>
              <li>Logged in users now go right to the home page</li>
              <li>small visual adjustments site-wide</li>
              <li>fixed an issue on the server where updated emails wouldn't send</li>
              <li>changed your dashboard overview grid to show all your updates</li>
              <li>added acura images</li>
            </ul>
          </ChangelogContainer>
          
          <ChangelogContainer version="1.22" date="May 14th, 2025">
            <ul>
              <li>removed private beta notice on the home page</li>
              <li>visually fixed the user rows</li>
              <li>hiding the follow button if you're viewing your own content</li>
              <li>fixed cards on the brand index</li>
              <li>added subaru brand images</li>
              <li>fixed an issue where certain images would upload as blank</li>
              <li>added email notices when someone you follow creates or updates garage cars and events</li>
              <li>toned down the contrast of the car/event stat boxes</li>
              <li>“Yours” green banners are now anchored at the top of the page</li>
              <li>featured article cards now constrained to the width of the article column</li>
              <li>improvements to the style of the post panel</li>
            </ul>
          </ChangelogContainer>

          <ChangelogContainer version="1.21" date="May 12th, 2025">
            <ul>
              <li>You can now follow other users</li>
              <li>Follow buttons added to the users list on the society pages</li>
              <li>Follow button added to the user profile page</li>
              <li>Followers/following count boxes added to the dashboard and profile pages</li>
              <li>Clicking on the count boxes opens up a paginated list of your followers and those you are following</li>
              <li>Home page: added new feed that's posts from users you follow</li>
              <li>Ensure email comparison is lowercase when logging in</li>
              <li>Restored the registration page publically</li>
              <li>Removed all "apply for membership" links and change buttons to go to the registration page</li>
              <li>Hooked up a designed welcome email sent to newely registered users</li>
              <li>Hooked up emails for when someone comments on your post</li>
              <li>Hooked up emails for when someone likes on your post</li>
              <li>Hooked up emails for when someone follows you</li>
              <li>Hooked up emails for when members whom you follow post content</li>
              <li>Added email settings to the dashboard</li>
            </ul>
          </ChangelogContainer>
          
          <ChangelogContainer version="1.15" date="May 7th, 2025">
            <ul>
              <li>Version badge links to changelog</li>
              <li>Updated roadmap</li>
              <li>Fixed event type for drives, no longer says "test"</li>
              <li>Drive events now show up on /society/rallys</li>
              <li>Contact button on event detail page doesn't collide with the user badge</li>
              <li>Event organizer box now stays full width</li>
              <li>Detail pages for cars, events, and users have the corresponding subnav for those sections</li>
              <li>Subnav and breadcrumbs now stretch to fill the width of the screen</li>
              <li>Fixed horizontal scroll issues on article detail pages</li>
              <li>Attending or declining an event reloads the page so you see the correct attendees list</li>
              <li>Card badges now have correct spacing</li>
              <li>Fixed a z-index issue for the home slider pagination</li>
              <li>Fixed home slide text color</li>
              <li>Softened mobile gradient for home slide show</li>
              <li>Make and model required when creating a garage car</li>
              <li>Fixed a bug where no make/model would break the car detail page</li>
            </ul>
          </ChangelogContainer>
          
          <ChangelogContainer version="1.14" date="April 26th, 2025">
            <ul>
              <li>New Article</li>
              <li>Slideshow for the home page</li>
              <li>Featured user, car, and events grid added to the article detail page</li>
            </ul>
          </ChangelogContainer>

          <ChangelogContainer version="1.13" date="April 25th, 2025">
            <ul>
              <li>New style for header</li>
              <li>New mobile navigation</li>
              <li>New main font-face</li>
              <li>Added search</li>
            </ul>
          </ChangelogContainer>

          <ChangelogContainer version="1.12" date="April 23rd, 2025">
            <ul>
              <li>fixed the avants event paragraph text being too large</li>
              <li>fixed the category of the avants event (now shows in past)</li>
              <li>fixed the logic that sets the event date for better comparison</li>
              <li>allow articles to be marked private</li>
              <li>show private entries in your dashboard</li>
              <li>allow articles to have inline images</li>
              <li>added Volkswagen images to brand pages</li>
            </ul>
          </ChangelogContainer>
          
          <ChangelogContainer version="1.11" date="April 15th, 2025">
            <ul>
              <li>Fixed an issue where the app would log you out every 12 hours</li>
              <li>fixed the fallback image on gallery carousels (sometimes it wouldn’t fill the available space)</li>
            </ul>
          </ChangelogContainer>
          
          <ChangelogContainer version="1.1" date="April 13th, 2025">
            <ul>
              <li>Events live and functional</li>
              <ul>
                <li>Attendees works on the event detail page</li>
                <li>You can toggle wether or not you want to go to this event</li>
                <li>Shows a list of attendees</li>
                <li>Event details and map shown on the detail page</li>
                <li>Event Listing page splits up listings with upcomming, recurring, and past</li>
                <li>Splitting up event listings on the society index page</li>
              </ul>
              <li>Shorter user rows for event attendees</li>
              <li>Footer styles for desktop match mobile</li>
            </ul>
          </ChangelogContainer>

          <ChangelogContainer version="1.04" date="April 12th, 2025">
            <ul>
              <li>adding new items to event forms</li>
              <li>fixing new and update event actions</li>
              <li>fixed feed of other events</li>
              <li>added event details to the front-end</li>
              <li>added “contact” button if the user allows emails</li>
              <li>added map if link exists for the event</li>
              <li>Fixed an issue creating new events, where your user and event type weren't set correctly</li>
              <li>Added help text for embedding google maps</li>
              <li>Hide UI elements within the card image on small screens</li>
              <li>Correct badge on events grid items</li>
              <li>Correct query for /drives</li>
              <li>Add banners to event detail pages</li>
              <li>Add category badge to the event detail page</li>
              <li>Format the event type correctly in the box on the detail page</li>
              <li>Austin changed to MINI Classic</li>
              <li>Added models for MINI</li>
              <li>Comments now in a collapsable container</li>
              <li>No comments now doesn’t look like an error</li>
              <li>If there is no items for a feed, then nothing will show now</li>
              <li>Dates added to the cards for spotted, and user posts</li>
              <li>rows are rounded</li>
            </ul>
          </ChangelogContainer>
          
          <ChangelogContainer version="1.03" date="April 9th, 2025">
            <ul>
              <li>Added more content to the welcome page</li>
              <li>Fixed an issue where the post pane top badges would overlap the edit window</li>
              <li>made the edit pane shorter so that when 2 panes are open, it’s a staggered effect</li>
              <li>Centralized the large buttons in new to a TapButton</li>
              <li>Using new TapButton for edit pane</li>
              <li>New UI for member user rows</li>
              <li>If allow email, then show an email icon in the row which opens up email</li>
              <li>Default profile picture added</li>
              <li>rounded buttons site-wide</li>
            </ul>
          </ChangelogContainer>
          
          <ChangelogContainer version="1.02" date="April 4th, 2025">
            <ul>
              <li>Added gallery to the car detail section of the garage car page</li>
              <li>Styled car detail cards/tabs better</li>
              <li>added KIA images to the brands page</li>
              <li>Updated the posts to have custom year/make/model/color fields, so for example if you see a Delorean, and you don’t have one in your garage, you can set that information</li>
              <li>Custom car info added in a collapsable accordion with help text explaining what to do</li>
              <li>Associations of a post (garage/event/etc) are now in a collapsable accordion for better UX</li>
              <li>Add user setting to allow email address to be shown on listings and profile</li>
              <li>Added a button to contact the user on listings, want-ads, and profiles if the setting allows</li>
              <li>Fixed view all users button on the home page</li>
              <li>Load more users on the members page working</li>
              <li>added many categories for cars</li>
              <li>added the ability to show category badges</li>
              <li>simplified the colors of the card badges</li>
              <li>Added relevant type and category badges accross the site</li>
            </ul>

            <p>Hotfixes</p>
            <ul>
              <li>added validation for spaces and less than 3 characters for usernames</li>
              <li>added help text for registration page regarding username and password rules</li>
              <li>descriptions added for projects and events in the new panel</li>
              <li>restored preview images when uploading</li>
            </ul>
          </ChangelogContainer>

          <ChangelogContainer version="1.01" date="April 1st, 2025">
            <p>Hotfixes</p>
            <ul>
              <li>fixed the issue that was causing the blank pages.</li>
              <li>Handleizing photo upload names correctly now, so for example, uploading a photo with a space in the file name will no longer cause an error</li>
              <li>drag and drop to rearrange your photos now works on both desktop and mobile</li>
              <li>On car detail pages, more [brand] cars feed at the bottom now pulls in data</li>
              <li>user/car badges are now black with white text to make them more visible</li>
              <li>Ability to update profile picture and profile banner on the settings page</li>
              <li>Fixed instances where the uploaded profile photo wouldn't work</li>
              <li>Fixed some instances where reloading the page in a new browser/tab would log you out</li>
              <li>Home page carousel image now supports title, description, and buttons</li>
              <li>Added new panel when the large red plus icon is clicked in the header, which opens up a pane of new posting options</li>
              <li>Better image validation on the profile and banner images (can't upload HEIC, only let you pass when a valid image is selected)</li>
            </ul>
          </ChangelogContainer>
          
          <ChangelogContainer version="1.0" date="April 1st, 2025">
            <ul>
              <li>Launched Version 1 of the site.</li>
            </ul>
          </ChangelogContainer>

        </div>
      </PSPage>
    </>
    
  );
};

export default Changelog;
